import { render } from "./want_product.vue?vue&type=template&id=7760c9e8"
import script from "./want_product.vue?vue&type=script&lang=js"
export * from "./want_product.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__